import $ from 'jquery';

// When the utility navigation search toggle is clicked,
// hide the toggle element and display the utility navigation search form

const $utilityNavigationSearchToggle = $('#utility-navigation-search-toggle');
const $utilityNavigationSearchForm = $('#utility-navigation-search-form');

$utilityNavigationSearchToggle.click(function() {
  $utilityNavigationSearchToggle.hide();

  $utilityNavigationSearchForm.css({
    'display': 'flex'
  });

  $utilityNavigationSearchForm.find('input').focus();
});